import { UnicodeEntity } from '@mews/enums';

export const Dash = () => <span>{UnicodeEntity.Dash}</span>;
